export const pieChartConfig = (title: string, name: string, data: { label: string; value: string }[]) => ({
  tooltip: {
    trigger: "item"
  },
  toolbox: {
    show: true,
    right: 20,
    feature: {
      saveAsImage: {
        title: title,
        backgroundColor: "transparent"
      }
    }
  },
  legend: {
    orient: "horizontal",
    bottom: 0
  },
  series: [
    {
      name: name,
      type: "pie",
      radius: "70%",
      data: data,
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.2)"
        }
      },
      label: {
        textBorderColor: "transparent"
      }
    }
  ]
});
